<template>
    <div :class="{ simple: true }">
        <!-- <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :viewBox="'0 0 ' + wWidth + ' ' + wHeight" width="80%" preserveAspectRatio="none" >
            <defs>
                <linearGradient id="a" x1="0%" y1="0%" x2="0%" y2="100%" gradientUnits="userSpaceOnUse" gradientTransform="rotate(-15)">
                    <stop offset="0%" stop-color="#e3bd52"/>
                    <stop offset="100%" stop-color="#9d681b"/>
                </linearGradient>
                <clipPath id="kijkgat">
                    <rect x="0" y="0" :width="wWidth" height="20" />
                    <rect x="0" y="0" width="20" height="100%" />
                    <rect :x="( wWidth - 20 ) + 'px'" y="0" width="20" height="100%" />
                    <polygon :points="polyPath" />
                </clipPath>
            </defs>
            <rect x="0" y="0" width="100%" height="100%" fill="url(#a)" clip-path="url(#kijkgat)" />
        </svg> -->
        <div :class="{ 'bg-visual': true, [sky]: true }">
        </div>

        <div :class="{ 'sun': true, [sun]: true }"></div>

        <img class="stl-label" src="/static/img/stl-label.png" />

        <div class="content">
            <svg class="golden-border" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :viewBox="'0 0 ' + wWidth + ' ' + wHeight"  preserveAspectRatio="none" >
                <defs>
                    <linearGradient id="gold-gradient" x1="0%" y1="0%" x2="0%" y2="100%" gradientUnits="userSpaceOnUse" gradientTransform="rotate(-15)">
                        <stop offset="0%" stop-color="#e3bd52"/>
                        <stop offset="100%" stop-color="#9d681b"/>
                    </linearGradient>
                    <clipPath id="kijkgat">
                        <rect x="0" y="0" :width="wWidth" :height="borderWidth" />
                        <rect x="0" y="0" :width="borderWidth" height="100%" />
                        <rect :x="( wWidth - borderWidth ) + 'px'" y="0" :width="borderWidth" height="100%" />
                        <polygon :points="polyPath" />
                    </clipPath>
                </defs>
                <rect x="0" y="0" width="100%" height="100%" fill="url(#gold-gradient)" clip-path="url(#kijkgat)" />
            </svg>
            <slot></slot>
        </div>

        <footer>
            <div class="content-wrapper">
                <img src="/static/img/logos/footer.png" />
                <p class="disclaimer">Voor het organiseren van Staatsloterij is aan Staatsloterij bv vergunning verleend door de Kansspelautoriteit, trekking Laan van Hoornwijck 55 te Rijswijk.<br />Deelname vanaf 18 jaar. Als je aan deze actie meedoet, dan accepteer je onze <a :href="'/static/pdf/actievoorwaarden.pdf'" target="_blank">actievoorwaarden</a>. | <a href="https://www.nederlandseloterij.nl/privacy" target="_blank">Privacy Statement</a> Nederlandse Loterij</p>
            </div>
        </footer>
        <!--div class="footer-wrapper">
            <ul>
                <li><a href="/static/pdf/actievoorwaarden.pdf" target="_blank">Actievoorwaarden</a></li><li><a href="https://staatsloterij.nederlandseloterij.nl/" target="_blank">staatsloterij.nl</a></li><li>&copy;2018</li><li class="eighteen">Speel bewust <span>18+</span></li>

            </ul>

            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1082 127.5" width="100%" height="100px" preserveAspectRatio="none">
                <defs>
                    <linearGradient id="gold-bottom" y1="80.22" x2="1081" y2="80.22" gradientUnits="userSpaceOnUse">
                        <stop offset="0" stop-color="#a37424" />
                        <stop offset="1" stop-color="#99681c"/>
                    </linearGradient>
                </defs>
                <line class="golden-border" x1="0" y1="10" x2="1082" y2="10" style="fill:none;stroke:url(#gold-bottom);stroke-miterlimit:10;stroke-width:20px"/>
            </svg>
        </div-->
    </div>
</template>

<style lang="scss" scoped>
    svg{
        width:100%;
        height:100%;
        position:absolute;
        top:0;
        left:0;
        pointer-events:none;
    }
</style>

<script>
    export default {
        data()
        {
            return {
                wHeight: document.documentElement.getBoundingClientRect().height,
                wWidth: window.innerWidth,
                borderWidth: 15
            };
        },

        computed: {
            polyPath()
            {
                return '0,' + this.wHeight + ' ' + this.wWidth + ',' + this.wHeight + ' ' + this.wWidth + ',' + ( this.wHeight - 75 ) + ' 0,' + ( this.wHeight - 50 );
            },
            sky()
            {
                return this.$store.getters.sky;
            },
            sun()
            {
                return this.$store.getters.sun;
            }
        },

        mounted()
        {
            window.addEventListener( 'resize', this.onResize );
            this.onResize();
        },

        methods: {
            onResize()
            {
                this.wHeight = document.documentElement.getBoundingClientRect().height;
                this.wWidth = window.innerWidth;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/layouts/Simple.vue